module.exports = __webpack_public_path__ + "img/AntiMage.b68ee86a.png";